import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Npo } from '../models/npo.model';
import { DppEnrollmentFacade } from '../store/facade/dpp-enrollment.facade';

@Component({
    selector: 'fc-npo-search-modal',
    templateUrl: './npo-search-modal.container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NpoSearchModalContainerComponent {
    npoSearchCallStatus$ = this.dppEnrollmentFacade.npoSearchCallStatus$;
    npoSearchResults$ = this.dppEnrollmentFacade.npoSearchResults$;
    pageNumber$ = this.dppEnrollmentFacade.pageNumber$;

    constructor(private readonly dppEnrollmentFacade: DppEnrollmentFacade) {}

    npoSearched(ein: string): void {
        this.dppEnrollmentFacade.npoSearched(ein);
    }

    npoSelected(npo: Npo): void {
        this.dppEnrollmentFacade.npoSelected(npo);
    }

    pageChanged(pageNumber: number): void {
        this.dppEnrollmentFacade.pageChanged(pageNumber);
    }
}
